import React from 'react'

import makeStyles from './styles';
import {MainSlider} from '../../components/Slider/Slider'

export default function MainPage(){
  return (
    <div>
      <MainSlider/>
    </div>
  )
}
